var parent = require('../../es/object/values');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/features/object/values.js
// module id = 1648
// module chunks = 1